var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BButton',_vm._b({attrs:{"variant":_vm.variantColor,"disabled":_vm.disabled},on:{"click":_vm.executeServerAction}},'BButton',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }